import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUkNewDutyProductType implements BaseEnumType {
  private static allValues: EnumUkNewDutyProductType[] = []; // make sure this is top-most
  
  public static none = new EnumUkNewDutyProductType(0, "None", "enum_uk_new_duty_product_type_none");
  public static beer = new EnumUkNewDutyProductType(1, "Beer", "enum_uk_new_duty_product_type_beer");
  public static wine = new EnumUkNewDutyProductType(2, "Wine", "enum_uk_new_duty_product_type_wine");
  public static spirits = new EnumUkNewDutyProductType(3, "Spirits", "enum_uk_new_duty_product_type_spirits");
  public static stillCider = new EnumUkNewDutyProductType(4, "StillCider", "enum_uk_new_duty_product_type_still_cider");
  public static sparklingCider = new EnumUkNewDutyProductType(5, "SparklingCider", "enum_uk_new_duty_product_type_sparkling_cider");
  public static otherFermented = new EnumUkNewDutyProductType(6, "OtherFermented", "enum_uk_new_duty_product_type_other_fermented");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUkNewDutyProductType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumUkNewDutyProductType.none; }
  public isBeer() { return this === EnumUkNewDutyProductType.beer; }
  public isWine() { return this === EnumUkNewDutyProductType.wine; }
  public isSpirits() { return this === EnumUkNewDutyProductType.spirits; }
  public isStillCider() { return this === EnumUkNewDutyProductType.stillCider; }
  public isSparklingCider() { return this === EnumUkNewDutyProductType.sparklingCider; }
  public isOtherFermented() { return this === EnumUkNewDutyProductType.otherFermented; }

  public static getValues(): readonly EnumUkNewDutyProductType[] {
    return EnumUkNewDutyProductType.allValues;
  }

  public static getValuesExcept0(): readonly EnumUkNewDutyProductType[] {
    return EnumUkNewDutyProductType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUkNewDutyProductType {
    const found = EnumUkNewDutyProductType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUkNewDutyProductType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUkNewDutyProductType): EnumUkNewDutyProductType {
    const found = name ? EnumUkNewDutyProductType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUkNewDutyProductType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUkNewDutyProductType>): boolean {
    return this.key === other?.key;
  }
}